"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretRight = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CaretRight = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M10.483 17.793a.7.7 0 01-.993 0l-.28-.28A.686.686 0 019 17.01V6.991a.686.686 0 01.21-.504l.28-.28a.7.7 0 01.993 0l5.304 5.303a.671.671 0 010 .98l-5.304 5.303z" })); };
exports.CaretRight = CaretRight;
//# sourceMappingURL=caret-right.js.map